import translations from '../../components/location/ts/sv-SE';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('sv-SE', translations);
